<style src="./ItemList.scss" lang="scss"></style>

<template lang="pug">
  section.itemlist(
    :class='`is-${view || "cards"}`'
  )
    header.itemlist__header(
      v-if='showYearSelect || showLangSelect || links.length || title'
      :class='{ "has-title": title }'
    )
      .itemlist__headline(
        v-if='title'
      )
        h2.itemlist__title {{ title }}

      .itemlist__selects(
        v-if='showYearSelect || showLangSelect'
      )
        .itemlist__select(
          v-if='showYearSelect'
        )
          Select(
            @change='yearSelect.handler'
            :selected='yearSelect.raw[params.year]'
            :placeholder='yearSelect.placeholder'
            :options='yearSelect.options'
          )
        .itemlist__select(
          v-if='showLangSelect'
        )
          Select(
            @change='langSelect.handler'
            :selected='langSelect.raw[params.year]'
            :placeholder='langSelect.placeholder'
            :options='langSelect.options'
          )
      .itemlist__links(
        v-if='links.length'
      )
        router-link.itemlist__link(
          v-for='link in links'
          :key='link.label'
          :class='isLinkActive(link)'
          :to='link'
        ) {{ link.label }}

    .itemlist__body
      p.itemlist__message(
        v-if='!items.length && !creator'
      ) {{ emptyMessage }}
      ul.itemlist__list(
        v-else
        :class='{"grid is-columns": view !== "list"}'
        :style='listStyle'
      )
        li.itemlist__item(
          v-if='creator'
          key='creator'
          :class='{"col-20p col-lg-3 col-m-4 col-s-6": view !== "list"}'
        )
          EmptyItem(
            :title='creator.title'
            :label='creator.label'
            :href='creator.href'
            :action='creator.action'
          )

        li.itemlist__item(
          v-if='item'
          v-for='(item, index) in items'
          :class='{"col-20p col-lg-3 col-m-4 col-s-6": view !== "list"}'
          :key='item.id'
          :style='`z-index: ${items.length - index}`'
        )
          Track(
            v-if='type === "tracks"'
            :type='view === "list" ? view : "card"'
            :tracklist='tracklist'
            :index='tracklist ? index : 0'
            :track='item'
            :playlist-id='playlistId'
            :removable='removable'
          )
          Album(
            v-if='type === "albums"'
            type='card'
            :album='item'
            :removable='removable'
            :editable='editable'
            :review='review'
            :checkable='checkable'
            :checked='checked.includes(item.id)'
            :show-controls='!removable'
            @check='check(item.id)'
            @uncheck='uncheck(item.id)'
          )
          Artist(
            v-if='type === "artists"'
            type='card'
            :artist='item'
          )
          Genre(
            v-if='type === "genres"'
            type='card'
            :genre='item'
          )
          Playlist(
            v-if='type === "playlists"'
            :type='item.type || "card"'
            :playlist='item'
          )

    .itemlist__footer(
      v-if='pagination && pagination.total > pagination.limit'
    )
      .itemlist__pagination
        Pagination(
          :per-page='pagination.limit'
          :total='pagination.total'
          :current='pagination.current_page'
        )
</template>
<script>
import Track from "@/components/Track/Track";
import Album from "@/components/Album/Album";
import Artist from "@/components/Artist/Artist";
import Genre from "@/components/Genre/Genre";
import Playlist from "@/components/Playlist/Playlist";
import EmptyItem from "@/components/EmptyItem/EmptyItem";
import Select from "@/components/Select/Select";
import Pagination from "@/components/Pagination/Pagination";

export default {
  props: {
    emptyMessage: String,
    type: String,
    removable: Boolean,
    editable: Boolean,
    review: Boolean,
    checkable: Boolean,
    view: String,
    title: String,
    items: {
      type: Array,
      default: () => []
    },
    tracklist: Object,
    playlistId: String,
    params: Object,
    creator: Object,
    yearSelect: Object,
    langSelect: Object,
    links: {
      type: Array,
      default: () => []
    },
    pagination: Object
  },
  data() {
    return {
      checked: []
    };
  },
  components: {
    Track,
    Album,
    Artist,
    Genre,
    Playlist,
    EmptyItem,
    Select,
    Pagination
  },
  computed: {
    showYearSelect() {
      return (
        this.yearSelect &&
        this.yearSelect.options &&
        this.yearSelect.options.length
      );
    },
    showLangSelect() {
      return (
        this.langSelect &&
        this.langSelect.options &&
        this.langSelect.options.length
      );
    },
    listStyle() {
      return (
        this.view === "list" &&
        `counter-reset: trackNumber ${this.pagination &&
          (this.params.page - 1) * this.pagination.limit};`
      );
    }
  },
  methods: {
    isLinkActive(link) {
      return (
        (this.params.order || this.params.target) === link.type && "is-active"
      );
    },
    check(id) {
      this.checked.push(id);
      this.$emit("checked", this.checked);
    },
    uncheck(id) {
      this.checked = this.checked.filter(item => item !== id);
      this.$emit("checked", this.checked);
    }
  }
};
</script>
